export var style = function style(_ref) {
  var toolkitTheme = _ref.toolkit;
  var _toolkitTheme$palette = toolkitTheme.palette,
      type = _toolkitTheme$palette.type,
      grey10 = _toolkitTheme$palette.grey10,
      grey20 = _toolkitTheme$palette.grey20,
      grey600 = _toolkitTheme$palette.grey600,
      grey700 = _toolkitTheme$palette.grey700,
      grey800 = _toolkitTheme$palette.grey800,
      white = _toolkitTheme$palette.white,
      spacing = toolkitTheme.spacing;
  var background = type === 'light' ? white : grey800;
  var foreground = type === 'light' ? grey700 : grey10;
  var backgroundSecondary = type === 'light' ? grey20 : grey600;

  var createDensityStyle = function createDensityStyle(density) {
    var spacingMixin = spacing[density].spacing;
    return {
      padding: spacingMixin(3)
    };
  };

  return {
    root: {
      backgroundColor: background,
      width: '100%',
      height: '100%',
      overflow: 'auto',
      boxSizing: 'border-box',
      color: foreground
    },
    secondary: {
      backgroundColor: backgroundSecondary
    },

    /* Styles applied to the root element if `density="touch"` */
    touchDensity: createDensityStyle('touch'),

    /* Styles applied to the root element if `density="low"` */
    lowDensity: createDensityStyle('low'),

    /* Styles applied to the root element if `density="medium"` */
    mediumDensity: createDensityStyle('medium'),

    /* Styles applied to the root element if `density="high"` */
    highDensity: createDensityStyle('high')
  };
};